<template>
    <div v-if="pgIsProductSpecs" class="mt-2">
        <div v-for="(specs, specsKey) in productSpecs">
            <div v-if="!specs.collapse">
                <div class="mt-2">
                    <label class="text-black">Field Type<span class="text-danger">*</span></label>
                    <select class="form-control" v-model="specs.type">
                        <option :value="null" selected disabled>Select Field Type</option>
                        <option v-for="(value, key) in productServicesCustomFieldData" :value="key">{{ value }}</option>
                    </select>
                </div>
                <div class="mt-2" v-if="specs.type">
                    <label class="text-black">Field Name<span class="text-danger">*</span></label>
                    <input class="form-control" :id="'specsFieldNameInput-'+specsKey" type="text" placeholder="Field Name" v-model="specs.name" @input="resetSpecsValidationError(specsKey)">
                    <small class="text-red" :id="'specsFieldNameError-'+specsKey" style="display: none;">Field name is required.</small>
                </div>
                <div class="mt-2" v-if="specs.type == 1 || specs.type == 2 || specs.type == 3">
                    <div>
                        <small class="text-black">{{ specs.type == 3 ? 'Radio' : 'Dropdown' }} options - {{ productServicesCustomFieldData[specs.type] }} (Enter one option per line)</small>
                        <div class="row my-2" v-for="(option, optKey) in specs.options">
                            <div class="col-6">
                                <input class="form-control" type="text" placeholder="Name" v-model="option.name">
                            </div>
                            <div class="col-4">
                                <input class="form-control" type="number" placeholder="Price" v-model="option.price" min="0" oninput="(validity.valid || parseFloat(value) > 0)||(value='');">
                            </div>
                            <div class="col-2 text-right">
                                <i class="fa fa-trash pointer" aria-hidden="true" @click="removeDropdownOptionInProductSpecs(specsKey, optKey)"></i>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <span class="pointer" @click="addDropdownOptionInProductSpecs(specsKey)">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            Add new {{ specs.type == 3 ? 'radio' : 'dropdown' }} item
                        </span>
                    </div>
                </div>
                <div class="mt-2" v-if="specs.type == 4">
                    <label class="text-black">Yes/No</label>
                    <select class="form-control" v-model="specs.boolValue">
                        <option value="yes" selected>Yes</option>
                        <option value="no" selected>No</option>
                    </select>
                </div>
                <div class="mt-2" v-if="specs.type == 4 || specs.type == 5">
                    <label class="text-black">Price Per Unit</label>
                    <input class="form-control" type="number" placeholder="Price" v-model="specs.price" min="0" oninput="(validity.valid || parseFloat(value) > 0)||(value='');">
                </div>
                <div class="mt-2 text-right" v-if="specs.type">
                    <button type="button" class="btn btn-primary" @click="tempSaveProductSpecs(specsKey)">Save</button>
                </div>
            </div>
            <div v-else>
                <div class="row my-2">
                    <div class="col-9">
                        <label class="text-black">{{ specs.name }}</label>
                    </div>
                    <div class="col-3 text-right">
                        <i class="fa fa-pencil pointer px-1" aria-hidden="true" @click="editProductSpecs(specsKey)"></i>
                        <i class="fa fa-trash pointer px-1" aria-hidden="true" @click="removeProductSpecs(specsKey)"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-right" v-if="addMoreSpecsButton">
            <span class="pointer underline" @click="addProductSpecs">Add another property</span>
        </div>
    </div>
</template>

<script>
const productSpecsGeneric = {
    type: null,
    name: null,
    options: [
        {
            name: null,
            price: null,
        }
    ],
    boolValue: 'yes',
    price: null,
    collapse: false
    };
export default {
    name: "pg-product-and-services-product-specs",
    props: ['pgIsProductSpecs', 'productServicesCustomFieldData'],
    data() {
        return {
            productSpecs: [_.cloneDeep(productSpecsGeneric)],
            addMoreSpecsButton: false
        }
    },
    methods: {
        addProductSpecs() {
            this.productSpecs.push(_.cloneDeep(productSpecsGeneric));
            this.addMoreSpecsButton = false;
        },
        editProductSpecs(specsKey) {
            this.productSpecs[specsKey].collapse = false;
            this.addMoreSpecsButton = false;
        },
        removeProductSpecs(specsKey) {
            this.productSpecs.splice(specsKey, 1);
        },
        addDropdownOptionInProductSpecs(key) {
            this.productSpecs[key].options.push({name: null, price: null});
        },
        removeDropdownOptionInProductSpecs(specsKey, optKey) {
            this.productSpecs[specsKey].options.splice(optKey, 1);
        },
        tempSaveProductSpecs(specsKey) {
            if(this.productSpecs[specsKey].name !== null && this.productSpecs[specsKey].name !== undefined && $.trim(this.productSpecs[specsKey].name) !== "") {
                this.productSpecs[specsKey].collapse = true;
                this.addMoreSpecsButton = true;
                $("#specsFieldNameInput-" + specsKey).css('border', '');
                $("#specsFieldNameError-" + specsKey).css('display', 'none');
            }
            else {
                $("#specsFieldNameInput-" + specsKey).css('border', '1px solid #e3342f');
                $("#specsFieldNameError-" + specsKey).css('display', 'block');
            }
        },
        resetSpecsValidationError(specsKey) {
            $("#specsFieldNameInput-" + specsKey).css('border', '');
            $("#specsFieldNameError-" + specsKey).css('display', 'none');
        },
        resetProductSpecs() {
            this.productSpecs = [_.cloneDeep(productSpecsGeneric)];
        }
    }
}
</script>
